import { defineStore } from 'pinia';
import api from '@/../lib/api';

export const useColorsStore = defineStore('colors', {
  state: () => {
    return {
      colors: {
        data: [],
        status: '',
        error: '',
      },
      selectedColor: null,
    };
  },

  getters: {
    isColorsLoading() {
      return this.colors.status === 'loading';
    },
    colorsList() {
      return this.colors.data;
    },
  },

  actions: {
    async getColors() {
      this.colors.status = 'loading';
      try {
        const { data } = await api.colors.get();
        this.colors.data = data.colors;
        this.colors.status = 'success';
        this.colors.error = null;
        return Promise.resolve();
      } catch (e) {
        this.colors.status = 'error';
        this.colors.error = e;
        return Promise.reject(e);
      }
    },
    async createColor(payload) {
      const { data } = await api.colors.create(payload);
      return data;
    },
    async updateColor(payload) {
      const { data } = await api.colors.update(payload);
      return data;
    },
    async deleteColor(id) {
      const { data } = await api.colors.delete(id);
      return data;
    },
    async restoreColor(id) {
      const { data } = await api.colors.restore(id);
      return data;
    },
  },
});
